import React from 'react';
import {paths} from '../../common/dictionaries/urls';
import StockAdjustmentList from './list';
import StockAdjustmentForm from './form';
import DescriptionMantain from './listDescription';

export const stockAdjustmentRoutes = [
  {'component': <StockAdjustmentList />, 'path': paths.StockAdjustmentList},
  {'component': <StockAdjustmentForm />, 'path': paths.StockAdjustmentEditForm},
  {'component': <StockAdjustmentForm />, 'path': paths.StockAdjustmentCreateForm},
  {
    'component': <DescriptionMantain />,
    'path': paths.DescriptionMantainStockAdjustment,
  },
];
